(() => {
  if (window.UODyeEffectDisclosureInitialized) return;
  window.UODyeEffectDisclosureInitialized = true;

  const effectSelector = '.uo-yarn-information__effect';
  const explanationSelector = '.uo-yarn-information__effect-tooltip';

  const style = document.createElement('style');
  style.textContent = `
    .uo-yarn-information__effect[data-uo-disclosure-enhanced="true"] {
      cursor: auto;
    }

    .uo-yarn-information__effect-button {
      appearance: none;
      display: inline;
      margin: 0;
      padding: 0;
      border: 0;
      background: transparent;
      color: inherit;
      font: inherit;
      line-height: inherit;
      cursor: pointer;
      text-decoration-line: underline;
      text-decoration-style: dotted;
      text-decoration-color: rgb(var(--color-foreground-rgb) / 0.45);
      text-underline-offset: 0.18em;
    }

    .uo-yarn-information__effect-button:focus-visible {
      outline: 2px solid #00b2aa;
      outline-offset: 3px;
    }

    .uo-yarn-information__effect[data-uo-disclosure-enhanced="true"] .uo-yarn-information__effect-tooltip[hidden] {
      display: none !important;
    }

    .uo-yarn-information__effect[data-uo-disclosure-enhanced="true"].is-open .uo-yarn-information__effect-tooltip {
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      transform: translateY(0) !important;
    }
  `;
  document.head.appendChild(style);

  const closeEffect = (effect, returnFocus = false) => {
    const button = effect.querySelector('.uo-yarn-information__effect-button');
    const explanation = effect.querySelector(explanationSelector);
    if (!button || !explanation) return;

    effect.classList.remove('is-open');
    explanation.hidden = true;
    button.setAttribute('aria-expanded', 'false');

    if (returnFocus) button.focus();
  };

  const closeOtherEffects = (activeEffect) => {
    document.querySelectorAll(`${effectSelector}.is-open`).forEach((effect) => {
      if (effect !== activeEffect) closeEffect(effect);
    });
  };

  const enhanceEffect = (effect) => {
    if (!(effect instanceof HTMLElement) || effect.dataset.uoDisclosureEnhanced === 'true') return;

    const explanation = effect.querySelector(explanationSelector);
    if (!(explanation instanceof HTMLElement)) return;

    const effectName = Array.from(effect.childNodes)
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .map((node) => node.textContent || '')
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!effectName) return;

    if (!explanation.id) {
      explanation.id = `DyeEffect-${Math.random().toString(36).slice(2, 10)}`;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'uo-yarn-information__effect-button';
    button.textContent = effectName;
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', explanation.id);

    explanation.hidden = true;
    explanation.removeAttribute('role');

    effect.removeAttribute('tabindex');
    effect.removeAttribute('aria-describedby');
    effect.replaceChildren(button, explanation);
    effect.dataset.uoDisclosureEnhanced = 'true';

    button.addEventListener('click', () => {
      const willOpen = !effect.classList.contains('is-open');
      closeOtherEffects(effect);

      if (willOpen) {
        explanation.hidden = false;
        effect.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      } else {
        closeEffect(effect);
      }
    });

    button.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && effect.classList.contains('is-open')) {
        event.preventDefault();
        closeEffect(effect, true);
      }
    });
  };

  const enhanceAll = (root = document) => {
    if (root instanceof Element && root.matches(effectSelector)) enhanceEffect(root);
    root.querySelectorAll?.(effectSelector).forEach(enhanceEffect);
  };

  enhanceAll();

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Node)) return;
    document.querySelectorAll(`${effectSelector}.is-open`).forEach((effect) => {
      if (!effect.contains(event.target)) closeEffect(effect);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openEffect = document.querySelector(`${effectSelector}.is-open`);
    if (openEffect instanceof HTMLElement) closeEffect(openEffect, true);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) enhanceAll(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
